import React from 'react';
/* eslint-disable */
import { useSelector } from 'react-redux';

// components
import { YesNo, Radio, TextInput, Select } from '../components/inputs';
import { FormRow } from '../components/layout';
import { Collapse } from '../../../common/components';

function PaymentMethod() {
  const { paymeth } = useSelector(store => store.values);

  return (
    <div>
      <FormRow>
        <Radio
          label="Payment method"
          name="paymeth"
          unsetFieldsOnCondition={{
            condition: (paymeth !== 'eft'),
            fieldsToUnset: [
              'eft_bankname',
              'eft_actnum',
              'eft_routing',
              'eft_acttype',
              'eft_sigdiff',
            ],
          }}
        >
          {(paymeth === 'eft') && (
            <>
              <FormRow className="pt-3 pb-0 mb-0">
                <TextInput
                  label="Account Holder Name"
                  name="eft_actname"
                  cols="7"
                  className="mb-3"
                />
                <TextInput
                  label="Bank Name"
                  name="eft_bankname"
                  cols="7"
                  className="mb-3"
                />
                <TextInput
                  label="Account Number"
                  name="eft_actnum"
                  cols="7"
                  className="mb-3"
                />
                <TextInput
                  label="Routing Number"
                  name="eft_routing"
                  cols="7"
                  className="mb-3"
                />
                <Select
                  label="Account Type"
                  name="eft_acttype"
                  cols="7"
                  className="mb-3"
                />
                <YesNo
                  label="Is signature different from owner?"
                  name="eft_sigdiff"
                  cols="7"
                  className="mb-3"
                />
              </FormRow>
            </>
          )}
        </Radio>
      </FormRow>
    </div>
  );
}

export default PaymentMethod;
